module.exports = "/_next/static/images/ee-2cb22dc7bd7fd7540fb197a67fba8b17.svg";